var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-primary video-time t-xs",class:_vm.color && 'bg-' + _vm.color},[_vm._v(_vm._s(_vm.duration))])}
var staticRenderFns = []

export { render, staticRenderFns }